import { render, staticRenderFns } from "./FeatureIcon.vue?vue&type=template&id=bcf2dc9a"
import script from "./FeatureIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports